
const navList: Array<string> = ['工单设置','工单必填项','提成设置','提醒设置 ',
// '短信设置',
// '回访设置',
'其他设置'];
import { defineComponent, ref, reactive, inject, onMounted, watch,Component, Ref } from "vue";
import { Request } from "@/api/request";
import { column } from "@/assets/types/common";
import Worksheet from './worksheet.vue'
import WorksheetRequired from './worksheetRequired.vue'
import Percentage from './percentage.vue'
import Remind from './remind.vue'
import Other from './other.vue'
export default defineComponent({
    name: "Operation",
    components:{
        Worksheet,
        Percentage,
        WorksheetRequired,
        Remind,
        Other
    },
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["运营设置"]);
        let navIndex = ref(0),
            worksheet:Ref<any> = ref(null),
            worksheetRequired:Ref<any> = ref(null),
            percentage:Ref<any> = ref(null),
            remind:Ref<any> = ref(null),
            other:Ref<any> = ref(null),
            component = [worksheet,worksheetRequired,percentage,remind,other]

        let setChange = (index:number) =>{
            component[index].value.dialogVisible = true;
        }
        return {
            navList,
            navIndex,
            worksheet,
            worksheetRequired,
            percentage,
            remind,
            other,
            setChange
        };
    },
});
